import { createBulkMutationHook } from "hooks/useMutationHandler";

import { DISMISS_NOTIFICATIONS } from "./gql";

export const useBulkDismissNotifications = createBulkMutationHook(DISMISS_NOTIFICATIONS);
